import { useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import useApi from "./../../../hooks/useAPI"
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { formatDinero } from '../../../utils/formatDinero'
import Avance from "../../../global/Avance"
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
})

export default function MDetalleReferencia({ ClaveViaje }) {
    const classes = useStyles();
    const [open, setOpen] = useState(false)
    const listaParticipantes = useApi(`package/KeyTravel/${ClaveViaje}`)
    const handleClickOpen = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    }
    return (
        <div>
            <Button onClick={handleClickOpen}>Ver grupo</Button>
            <Dialog
                open={open}
                scroll={'body'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={true}
                maxWidth={'md'}
            >
                <DialogTitle id="scroll-dialog-title">Grupo de viaje</DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}
                    >
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Total de pax.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="center">
                                            {listaParticipantes.reduce((a, b) => {
                                                return a + b.Paquete?.Numero_Personas
                                            }, 0)}
                                        </TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">#</TableCell>
                                        <TableCell align="center">Referencia</TableCell>
                                        <TableCell align="center">Nombre</TableCell>
                                        <TableCell align="center">Pax</TableCell>
                                        <TableCell align="center">Monto</TableCell>
                                        <TableCell align="center">Ahorro</TableCell>
                                        <TableCell align="center">Avance</TableCell>
                                        <TableCell align="center">Estatus</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {listaParticipantes.map((row, index) => (
                                        <TableRow key={row.Referencia}>
                                            <TableCell align="center">
                                                {index + 1}
                                            </TableCell>
                                            <TableCell align="center">
                                                <ButtonClienteDetalle referencia={row.Referencia} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.contratacion?.Cliente}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.Paquete?.Numero_Personas}
                                            </TableCell>
                                            <TableCell align="center">
                                                {`${formatDinero(row.Paquete?.Monto_Paquete)} ${row.Paquete?.Cotizacion?.Moneda.Clave}`}
                                            </TableCell>
                                            <TableCell align="center">
                                                {`${formatDinero(row.Paquete?.Cotizacion?.Suma)} ${row.Paquete?.Cotizacion?.Moneda.Clave}`}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Avance progress={row.Paquete?.Cotizacion?.Avance} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.Paquete?.EstatusProceso?.Descripcion}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}